export const dictionary = {
	'en-US': {
		'?': '?',
		'12_hour': '12 hour',
		'15_minutes': '15 minutes',
		'24_hour': '24 hour',
		'30_minutes': '30 minutes',
		'400_bad_request': '400 - Bad Request!',
		'404_not_found': '404 - Not found!',
		'404': '404',
		'45_minutes': '45 minutes',
		'500_something_went_wrong': '500 - Something went wrong!',
		'60_minutes': '60 minutes',
		'a_link_has_been_sent_to_the_users_email_but_the_user_has_not_clicked_on_it_yet': "A link has been sent to the user's email, but the user has not clicked on it yet.",
		'a_link_to_will_be_sent_to_your_email_by_clicking_on_that_you_can_reset_your_password_and_log_in_again': 'A link to will be sent to your email by clicking on that, you can reset your password and login again.',
		'a_one_time_password_and_a_link_sent_to_your_email_address_click_on_the_link_or_enter_the_code_below': 'A one-time password and a link sent to your email, click on the link or enter the code below:',
		'a_one_time_password_and_a_link_will_be_sent_to_your_email_you_can_enter_the_code_or_click_on_the_link_to_login_without_password': 'A one-time password and a link will be sent to your email, you can enter the code or click on the link to login without password.',
		'a_report_with_currently_selected_filters_will_be_generated_and_sent_to_the_admin_email_address': 'A report with currently selected filters will be generated and sent to the admin email address.',
		'a_validation_email_will_be_sent_to_the_email_by_clicking_on_the_link_in_that_email_the_user_can_login_into_the_admin': 'A validation email will be sent to the "{email}", by clicking on the link in that email, the user can login into the admin.',
		'about': 'About',
		'accept_permissions': 'Accept permissions',
		'action': 'Action',
		'actions': 'Actions',
		'add_another_interval': 'Add another interval',
		'add_extension': 'Add extension',
		'add_interval': 'Add interval',
		'add_new_service': 'Add New Service',
		'add_service': 'Add service',
		'add_team_member': 'Add Team Member:',
		'add_to_members_services': "Add to member's services",
		'add': 'Add',
		'adding_service_is_not_available_yet': 'Adding service is not available yet.',
		'admin_app_loader_main': 'Admin App Loader Main',
		'admin_appointment_details_info': 'Admin Appointment Details Info',
		'admin': 'Admin',
		'advanced': 'Advanced',
		'after_each_appointment': 'After each appointment',
		'after_reset_you_can_login_with_the_new_password': 'After reset, you can log in with the new password.',
		'after_saving_a_password_you_can_login_with_email_and_password_from_the_next_session': 'After saving a password, you can log in with email and password from the next session.',
		'all_appointments': 'All appointments',
		'all_apps': 'All apps',
		'all_rights_reserved': 'All rights reserved.',
		'all_settings_will_be_deleted_this_action_cant_be_undone': "All settings will be deleted, This action can't be undone.",
		'all_the_access_will_be_deleted_this_action_cant_be_undone': "All the access will be deleted, This action can't be undone.",
		'all': 'All',
		'allow_customers_to_cancel_their_appointments': 'Allow customers to cancel their appointments',
		'allow_customers_to_reschedule_their_appointments': 'Allow customers to reschedule their appointments',
		'allow_multiple_bookings_per_time_slot': 'Allow multiple bookings per time slot',
		'am': 'AM',
		'an_email_has_been_sent_to_the_team_members_email': "An email has been sent to the team member's email. The calendar will be linked once the team member authorizes Sesami on Google Calendar.",
		'an_email_with_a_calendar_event_will_be_sent_when_an_appointment_is_created_or_updated_your_customer_will_be_added_as_an_attendee': 'An email with a calendar event will be sent when an appointment is created or updated. Your customer will be added as an attendee.',
		'app_domain_sample': 'https://myapp.com',
		'app_extension_url_placeholder': 'https://myapp.com/extension',
		'app_name_wants_the_permission_to_access_the_resources_below': '{appName} wants the permission to access the resources below:',
		'app_names_have_to_be_unique': 'App names have to be unique.',
		'app_redirect_uri_sample': 'https://land.myapp.com',
		'app_updated': 'App updated',
		'apple': 'Apple',
		'apply_to_all': 'Apply to all',
		'apply_to': 'Apply to',
		'appointment_cancelled': 'Appointment cancelled',
		'appointment_created': 'Appointment created',
		'appointment_details': 'Appointment Details',
		'appointment_rescheduled': 'Appointment rescheduled',
		'appointment_started': 'Appointment started',
		'appointment': 'Appointment',
		'appointments_in_a_date': 'Appointments in a date',
		'appointments_report': 'Appointments report',
		'appointments': 'Appointments',
		'apps': 'Apps',
		'are_you_sure_you_want_to_cancel_the_appointment_this_is_a_one_way_operation': 'Are you sure you want to cancel the appointment? This is a one-way operation.',
		'are_you_sure_you_want_to_mark_the_customer_as_checked_in': 'Are you sure you want to mark the customer as checked in?',
		'are_you_sure_you_want_to_mark_the_customer_to_mark_as_a_no_show': 'Are you sure you want to mark the customer to mark as a no-show?',
		'assign_to_a_team_member': 'Assign to a team member',
		'automatically_refund_money_on_cancellation': 'Automatically refund money on cancellation',
		'availabilities_are_copied_from_the_team_member': 'Availabilities are copied from the team member',
		'availabilities': 'Availabilities',
		'available_times_will_be_shown_in_america_timezone': 'Available times will be shown in {timezone} timezone',
		'available_variables': 'Available Variables',
		'available': 'Available',
		'back_to_login': 'Back to login',
		'back_to_step_one': 'Back to step one',
		'back': 'Back',
		'basics': 'Basics',
		'before_each_appointment': 'Before each appointment',
		'before_the_first_appointment_on_the_same_day': 'Before the first appointment on the same day',
		'beta': 'Beta',
		'bio_sample': 'Personal trainer specialist',
		'bio': 'Bio',
		'body': 'Body',
		'book_an_appointment': 'Book an appointment',
		'book': 'Book',
		'booked': 'Booked',
		'booking_experience': 'Booking experience',
		'booking': 'Booking',
		'branding': 'Branding',
		'buffer_time': 'Buffer time',
		'build_your_own_flow_as_you_want_the_sky_is_the_limit': 'Build your own flow as you want, the sky is the limit!',
		'calendar_experience': 'Calendar experience',
		'calendar': 'Calendar',
		'can_be_installed_via_an_invitation_link': 'Can be installed via an invitation link.',
		'cancel_appointment': 'Cancel appointment',
		'cancel_the_appointment': 'Cancel the appointment',
		'cancel': 'Cancel',
		'cancellation_and_rescheduling': 'Cancellation and rescheduling',
		'cancelled': 'Cancelled',
		'cannot_login_maybe_the_url_is_expired_please_try_to_send_another_one': 'Cannot log in, maybe the URL is expired, please try to send another one.',
		'change_your_appointment_time_or_team_member': 'Change your appointment time or team member.',
		'change_your_service_settings_and_save_it': 'Change your service settings and save it.',
		'change_your_settings_and_then_save_it': 'Change your settings and then save it.',
		'check_in': 'Check-in',
		'check_whats_happening_in_your_sesami_world_your_service_commerce': "Check what's happening in your Sesami world, your service commerce!",
		'choose_a_customer': 'Choose a customer',
		'choose_a_slot': 'Choose a slot',
		'choose_an_app_for_your_shop': 'Choose an app for your shop.',
		'choose_from_a_flow_below_or_start_one_from_scratch': 'Choose from the flows below, or start one from scratch.',
		'choose_the_interval_for_the_slots_flexible_start_time': 'Choose the interval for the slots flexible start time.',
		'choose_which_fields_you_d_like_to_collect_for_instant_booking_selected_fields_will_be_required': "Choose which fields you'd like to collect for instant booking. Selected fields will be required.",
		'click_on_the_link_in_the_email_to_directly_login_to_your_account_without_password': 'Click on the link in the email to directly login to your account, without password.',
		'click_on_the_link_in_the_email_to_navigate_to_the_password_reset_page': 'Click on the link in the email to navigate to the password reset page',
		'click_or_drag_the_file_here_to_upload': 'Click or drag the file here to upload',
		'click_to_manage': 'Click to manage',
		'client_id': 'Client ID',
		'client_secret': 'Client secret',
		'close': 'Close',
		'complete_draft_order': 'Complete draft order',
		'configure_when_and_how_this_flow_should_be_triggered': 'Configure when and how this flow should be triggered',
		'confirm_new_password': 'Confirm new password',
		'confirm_password': 'Confirm password',
		'connect_your_google_account_to_sesami_and_you_will_able_to_login_without_password': 'Connect your Google account to Sesami and you will able to log in without password.',
		'connect_your_google_account': 'Connect your Google account:',
		'continue_with_google': 'Continue with Google',
		'continue': 'Continue',
		'copied': 'Copied',
		'copy_from_another_member': 'Copy from another member',
		'copy': 'Copy',
		'create_an_account': 'Create an account',
		'create_flow': 'Create Flow',
		'create_new_customer': 'Create new customer',
		'create_new_service_and_add_a_resource_to_it': 'Create new service and add a resource to it',
		'create_new_team_member_and_determine_availability': 'Create new team member and determine availability.',
		'create_new_user_and_add_permissions': 'Create a new user and add permissions',
		'create_new': 'Create new',
		'create_service': 'Create service',
		'create_team_member': 'Create Team Member',
		'create_user': 'Create User',
		'create': 'Create',
		'created': 'Created',
		'current_plan': 'Current Plan',
		'custom_options': 'Custom options',
		'customer_checked_in': 'Customer checked in',
		'customer_checkin': 'Customer check in',
		'customer_email': '{{CustomerEmail}}',
		'customer': 'Customer',
		'customers_can_book_multiple_appointments_per_time_slot': 'Customers can book multiple appointments per time slot.',
		'customers_can_complete_the_booking_in_the_sesami_pop_up_and_skip_the_checkout_recommended_for_free_or_post_paid_appointments': 'Customers can complete the booking in the Sesami pop-up and skip the checkout. Recommended for free or post-paid appointments',
		'customers_would_not_be_able_to_book_the_service_in_the_same_day': 'Customers would not be able to book the service on the same day.',
		'dashboard': 'Dashboard',
		'date_explanation': 'dd: Day, MM: Month number, NN: Month Name, yyyy: Year, hh: Hour, mm: Minute',
		'date_format_placeholder': 'dd NN yyyy hh:mm',
		'date_format': 'Date format',
		'date': 'Date',
		'days_after': 'Days after',
		'days_before': 'Days before',
		'decline': 'Decline',
		'deleted_service': 'Deleted service',
		'describe_your_app_in_a_short_form': 'Describe your app in a short form.',
		'description': 'Description',
		'details': 'Details',
		'developers': 'Developers',
		'disable_if_you_want_to_be_temporarily_unavailable': 'Disable if you want to be temporarily unavailable.',
		'disable_same_day_booking': 'Disable same day booking',
		'disabled': 'Disabled',
		'discard': 'Discard',
		'distribution': 'Distribution',
		'do_not_override': 'Do not override',
		'do_you_want_to_resend_the_email_confirmation_to': 'Do you want to resend the email confirmation to:',
		'doesnt_match_the_password': "Doesn't match the password",
		'domain': 'Domain',
		'downgrade': 'Downgrade',
		'draft_order_created_successfully': 'Draft order created successfully',
		'duration_is_not_set_for_any_of_variants': 'Duration is not set for any of variants',
		'duration': 'Duration',
		'edit_availability': 'Edit availability',
		'edit_your_email_body_here': 'Edit your email body here',
		'email_confirmation': 'Email confirmation',
		'email_is_required': 'Email is required',
		'email_reminder_to_customer': 'Email reminder to customer',
		'email_sample': 'my@email.com',
		'email_subject_cannot_be_empty': 'Email subject cannot be empty',
		'email_template': 'Email template',
		'email': 'Email',
		'enable_if_you_want_to_be_available': 'Enable if you want to be available.',
		'enable_instant_booking_for_this_service': 'Enable instant booking for this service',
		'enabled': 'Enabled',
		'end_time_must_be_after_start_time': 'End time must be after start time',
		'enter_a_valid_email': 'Enter a valid email',
		'enter_new_password': 'Enter new password',
		'enter_the_admin_and_set_a_login_format_for_your_account': 'Enter the admin and set a login format for your account.',
		'enter_the_code': 'Enter the code',
		'enter_the_password': 'Enter the password',
		'enter_time_in_minutes': 'Enter time in minutes',
		'enter_your_email': 'Enter your email',
		'enter_your_password': 'Enter your password',
		'error_cannot_check_notifications': 'Error! Cannot check notifications',
		'error': 'Error',
		'event_note': 'Event note',
		'example_02_00_pm': 'Example: 02:00 PM',
		'example_14_00': 'Example: 14:00',
		'example_2023_02_19': 'Example: 2023-02-19',
		'example_24': 'Example: 24',
		'example_30': 'Example: 30',
		'example': 'Example',
		'experience_instant_booking_confirmation': 'Experience Instant Booking Confirmation',
		'experience_instant_booking_form': 'Experience Instant Booking Form',
		'experience': 'Experience',
		'export_appointments': 'Export appointments',
		'export': 'Export',
		'extensions': 'Extensions',
		'facebook': 'Facebook',
		'first_last_name_sample': 'John Connor',
		'first_name': 'First name',
		'flow_configuration': 'Flow configuration',
		'flow_created': 'Flow created',
		'flow_presets': 'Flows presets',
		'flow_removed': 'Flow removed',
		'flow_template': 'Flow template',
		'flow_updated': 'Flow updated',
		'flow': 'Flow',
		'flows_list': 'Flows List',
		'flows': 'Flows',
		'forbidden_access_denied': 'Forbidden! access denied.',
		'forbidden_you_dont_have_access_to_this_part': "Forbidden! you don't have access to this part.",
		'forgot_password_question': 'Forgot password?',
		'forgot_your_password': 'Forgot your password?',
		'friday_sum': 'Fridays',
		'from_colon': 'From:',
		'from': 'From',
		'go_to_home': 'Go to home',
		'go_to_login': 'Go to login',
		'google_calendar_sync_is_enabled': 'Google Calendar sync is enabled',
		'google_calendar_sync': 'Google Calendar sync',
		'google': 'Google',
		'got_it': 'Got it!',
		'grant_access': 'Grant Access',
		'grant_permission': 'Grant permission',
		'grant_shop_permission_to_create_an_admin': 'Grant shop permission to create an admin.',
		'group_appointments': 'Group Appointments',
		'group': 'Group',
		'headers': 'Headers',
		'help': 'Help',
		'hide_timezone_from_storefront_calendar': 'Hide timezone from storefront calendar',
		'hours_after': 'Hours after',
		'hours_before': 'Hours before',
		'how_to_add_options': 'How to add options?',
		'icon': 'Icon',
		'If_enabled_a_slot_will_be_blocked_for_the_specified_duration_upon_customers_selecting_a_time_and_confirming': 'If enabled, a slot will be blocked for the specified duration upon customers selecting a time and confirming.',
		'if_selected_sesami_s_name_would_be_hidden': "If selected, Sesami's name would be hidden.",
		'if_you_forget_your_password_you_can_reset_it_below': 'If you forget your password, you can reset it below.',
		'image_must_be_smaller_than_5MB': 'Image must be smaller than 5MB',
		'image': 'Image',
		'immediately': 'Immediately',
		'in_range_appointments': 'In range appointments',
		'info': 'Info',
		'insert_a_valid_email_to_enable_it': 'Insert a valid email to enable it',
		'install_app': 'Install App',
		'install': 'Install',
		'installed_apps': 'Installed apps',
		'installed': 'Installed',
		'instant_booking_required_fields': 'Instant booking required fields',
		'instant_booking': 'Instant booking',
		'intervals_should_not_interfere_each_other': 'Intervals should not interfere each other',
		'invalid_code': 'Invalid code',
		'just_compare_and_choose_the_best_plan_for_your_needs': 'Just compare and choose the best plan for your needs',
		'language': 'Language',
		'last_30_days': 'Last 30 days',
		'last_7_days': 'Last 7 days',
		'last_90_days': 'Last 90 days',
		'last_name_sample': 'Connor',
		'last_name': 'Last name',
		'leave_it_blank_to_allow_booking_for_any_number_of_days_in_the_future': 'Leave it blank to allow booking for any number of days in the future.',
		'leave_it_blank_to_allow_cancellation_rescheduling_until_when_the_appointment_starts': 'Leave it blank to allow cancellation/rescheduling until when the appointment starts',
		'leave_it_blank_to_start_from_the_current_date_default': 'Leave it blank to start from the current date.',
		'less_required_information_usually_leads_to_better_conversion_we_recommended_only_selecting_what_is_necessary': 'Less required information usually leads to better conversion, we recommended only selecting what is necessary.',
		'limit_the_number_of_days_clients_can_book_an_appointment_in_advance': 'Limit the number of days clients can book an appointment in advance.',
		'linking_google_calendar_is_pending': 'Linking Google Calendar is pending',
		'load_more': 'Load more',
		'loading': 'Loading...',
		'localize_and_customize_sesami': 'Localize and customize Sesami',
		'localize_and_customize_storefront': 'Localize and customize Storefront',
		'location_placeholder': 'e.g. 100 Montreal, Skype, GoToMeeting, Google meet, ...',
		'location': 'Location',
		'login_to_sesami': 'Login to Sesami',
		'login_with_google': 'Login with Google',
		'login_with_magic_link': 'Login with magic link',
		'login_with_otp': 'Login with OTP',
		'login_with_password': 'Login with password',
		'login': 'Login',
		'logout': 'Logout',
		'magic_link_sent_to_your_email': 'Magic link sent to your email',
		'magic_link_sent': 'Magic link sent',
		'make_sure_the_body_is_valid_based_on_content_type': 'Make sure the body is valid based on "content-type"',
		'make_sure_the_headers_data_is_a_valid_json': 'Make sure the headers data is a valid JSON.',
		'manage_all_the_users': 'Manage all the users.',
		'manage_all_your_apps': 'Manage all your apps.',
		'manage_all_your_flows': 'Manage all your flows.',
		'manage_all_your_registered_apps': 'Manage all your registered apps.',
		'manage_all_your_services_or_create_a_new_one': 'Manage all your services or create a new one',
		'manage_all_your_team_members': 'Manage all your team members.',
		'manage_product': 'Manage Product',
		'manage_users_permissions_here': 'Manage users permissions here',
		'manage_your_app_here': 'Manage your app here.',
		'manage_your_flow_email_api_template': 'Manage your flow Email/API template',
		'manage_your_profile_here': 'Manage your profile here',
		'manage_your_team_member': 'Manage your team member',
		'manage': 'Manage',
		'mark_as_checked_in': 'Mark as checked in',
		'mark_as_no_show': 'Mark as no-show',
		'mark_as_paid_or_send_an_invoice_appointment_will_be_booked_as_soon_as_the_order_is_completed': 'Mark as paid or send an invoice, Appointment will be booked as soon as the order is completed.',
		'max_bookable_days': 'Max bookable days',
		'max_bookings_per_time_per_team_member': 'Max bookings per time per team member',
		'max_file_size_is_5mb_and_the_valid_file_formats_are_jpg_and_png': 'Max file size is 5MB, and the valid file formats are JPG and PNG.',
		'maximum_is': 'Maximum is',
		'min': 'min',
		'minutes_after': 'Minutes after',
		'minutes_before': 'Minutes before',
		'minutes_hours_or_days_after_before_the_event_happens': 'Minutes, hours, or days after/before the event happens',
		'minutes': 'Minutes',
		'mobile_sample': '+124922345571',
		'mobile': 'Mobile',
		'monday_sum': 'Mondays',
		'more_three_dots': 'More...',
		'more': 'More',
		'must_be_6_characters': 'Must be 6 characters',
		'must_be_a_valid_email': 'Must be a valid email',
		'must_be_a_valid_url': 'Must be a valid URL',
		'must_be_an_integer': 'Must be an integer',
		'must_be_at_least_8_characters': 'Must be at least 8 characters',
		'must_contain_at_least_8_characters_including_uppercase_lowercase_number_and_special_case_character': 'Must contain at least 8 characters, including uppercase, lowercase, number, and special case character.',
		'must_specify_a_number': 'Must specify a number',
		'my_app_the_best_app': 'My App: The best app!',
		'my_app': 'My app',
		'my_apps_description': "My app's description",
		'name_sample': 'John',
		'name': 'Name',
		'navigate_to_the_main_page_and_start_fresh': 'Navigate to the main page and start fresh!',
		'network': 'Network',
		'new_app_registered': 'New app registered!',
		'new_user_has_been_created': 'New user has been created!',
		'new_user': 'New user?',
		'next_day': 'Next day',
		'next': 'Next',
		'no_appointments': 'No appointments',
		'no_customers': 'No customers',
		'no_durations': 'No Durations',
		'no_plan': 'No plan',
		'no_services': 'No services!',
		'no_show_question_mark': 'No show?',
		'no_show': 'No show',
		'no_team_members_left': 'No team members left',
		'no_team_members': 'No team members',
		'no_variants': 'No variants',
		'no_worries_well_send_you_reset_instructions': "No worries, we'll send you reset instructions.",
		'not_assigned': 'Not assigned',
		'not_available_yet': 'Not available yet',
		'not_available': 'Not available',
		'not_found': 'Not found',
		'note_a_limited_number_of_reports_can_be_generated_per_day': 'Note: A limited number of reports can be generated per day.',
		'note_if_you_revoke_the_sync_events_from_google_calendar_will_no_longer_affect_availabilities': "Note: If you revoke the sync, events from Google Calendar will no longer affect availabilities, and Sesami events will not be pushed to team member's Google Calendar.",
		'note_this_will_enable_your_team_to_see_their_appointments': 'Note: will enable your team to see their appointments on their personal calendar. Optionally adding a personal event in there will update and block that time in their Sesami calendar.',
		'note': 'Note',
		'nothing_found': 'Nothing found',
		'notice': 'Notice!',
		'notifications': 'Notifications',
		'number_of_hours_customers_can_manage_their_appointment_before_the_start_time': 'Number of hours customers can manage their appointment before the start time',
		'number_of_participants': 'Number of participants',
		'ok': 'OK',
		'only_applies_to_payment_methods_that_can_be_refunded_automatically_eg_cash_payment_needs_to_be_handled_manually': 'Only applies to payment methods that can be refunded automatically (e.g. cash payment needs to be handled manually)',
		'oops_something_went_wrong': 'Oops! something went wrong.',
		'oops': 'Oops!',
		'or_login_with_otp': 'Or login with OTP',
		'or_login_with': 'Or login with',
		'order_id': 'Order ID',
		'order_name': 'Order name',
		'order': 'Order',
		'other_options': 'Other Options',
		'override_date_specific_rules': 'Override date specific rules?',
		'override': 'Override',
		'paid': 'Paid',
		'participant': 'Participant',
		'participants': 'Participants',
		'password_colon': 'Password:',
		'password_reset_link_sent_to_your_email': 'Password reset link sent to your email',
		'password': 'Password',
		'past_appointments': 'Past appointments',
		'past': 'Past',
		'pending': 'Pending',
		'permission_level': 'Permission level',
		'permission': 'Permission',
		'permissions': 'Permissions',
		'personal_info': 'Personal info',
		'phone': 'Phone',
		'pick_a_name_for_your_flow': 'Pick a name for your flow',
		'plans': 'Plans',
		'please_choose_a_slot_from_the_calendar': 'Please choose a slot from the calendar',
		'please_copy_the_client_secret_and_keep_it_somewhere_safe_after_this_you_cannot_access_the_client_secret_anymore': 'Please copy the client secret and keep it somewhere safe, after this you cannot access the client secret anymore:',
		'please_enter_a_valid_time_for_the_end': 'Please enter a valid time for the end',
		'please_enter_a_valid_time_for_the_start': 'Please enter a valid time for the start',
		'please_enter_and_save_a_unique_email_address_connected_to_google_calendar': 'Please enter and save a unique email address connected to Google Calendar.',
		'please_fill_up_this_online_form': 'Please fill up this online form: typeform.com/questionnaire',
		'please_join_the_meeting_using_this_link_https_zoom_us': 'Please join the meeting using this link: https://zoom.us/j/abcd',
		'please_save_the_form_first_and_then_try': 'Please save the form first and then try.',
		'please_type_remove_to_confirm': "Please type 'Remove' to confirm:",
		'please_type_revoke_to_confirm': 'Please type "Revoke" to confirm:',
		'pm': 'PM',
		'previous_3_months': 'Previous 3 months',
		'previous_day': 'Previous day',
		'previous_month': 'Previous month',
		'previous_week': 'Previous week',
		'previous': 'Previous',
		'price': 'Price',
		'privacy_policy': 'Privacy policy',
		'privacy': 'Privacy',
		'private': 'Private',
		'profile_updated': 'Profile updated',
		'profile': 'Profile',
		'public': 'Public',
		'range': 'Range',
		'read': 'Read',
		'redirect_uri': 'Redirect URI',
		'refresh': 'Refresh',
		'refunded': 'Refunded',
		'register_a_new_app_publish_it_or_use_it_as_private': 'Register a new app publish it or use it as private.',
		'register_a_new_app': 'Register A New App',
		'register_app': 'Register app',
		'register': 'Register',
		'registered_apps': 'Registered apps',
		'registered': 'Registered',
		'reminder_service_name_appointment_at_date_time_in_customer_timezone': 'Reminder: {{ServiceName}} appointment at {{DateTimeInCustomerTimezone}}',
		'remove_app': 'Remove app',
		'remove_extension': 'Remove extension',
		'remove_flow': 'Remove Flow',
		'remove_from_members_services': "Remove from member's services",
		'remove_interval': 'Remove interval',
		'remove_permission': 'Remove permission',
		'remove_service': 'Remove Service',
		'remove_sesami_branding': 'Remove Sesami branding',
		'remove_team_member': 'Remove team member',
		'remove_this_flow_and_all_its_settings': 'Remove this flow and all its settings',
		'remove_user': 'Remove user',
		'remove': 'Remove',
		'reschedule_reassign': 'Reschedule / Reassign',
		'rescheduled': 'Rescheduled',
		'resend_email_confirmation': 'Resend email confirmation',
		'resend': 'Resend',
		'reservation_period': 'Reservation period',
		'reservation': 'Reservation',
		'reserved': 'Reserved',
		'reset_password': 'Reset Password',
		'reset_your_password': 'Reset your password',
		'resource': 'Resource',
		'revoke': 'Revoke',
		'round_up_startup_interval_to': 'Round up startup interval to',
		'saturday_sum': 'Saturdays',
		'save_password': 'Save Password',
		'save_your_changes_then_try': 'Save your changes then try',
		'save': 'Save',
		'search_appointments': 'Search appointments',
		'search_apps': 'Search apps',
		'search_flows': 'Search flows',
		'search_name_email_phone': 'Search name, email, phone, ...',
		'search_presets': 'Search presets',
		'search_services': 'Search services',
		'search_shops': 'Search shops',
		'search_team_members': 'Search team members',
		'search_users': 'Search users',
		'search': 'Search',
		'see_and_manage_your_teams_schedule': 'See and manage your team\'s schedule.',
		'select_a_date': 'Select a date',
		'select_a_service': 'Select a service',
		'select_a_team_member': 'Select a team member',
		'select_a_trigger': 'Select a trigger',
		'select_the_level_of_permission_you_want_to_grant': 'Select the level of Permission you want to grant.',
		'select_the_type_of_permission_you_want_to_grant': 'Select the type of permission you want to grant.',
		'select_your_login_strategy': 'Select your login strategy:',
		'selected_colon': 'Selected:',
		'selected_slot': 'Selected slot',
		'selected': 'Selected',
		'send_calendar_invite': 'Send Calendar invite',
		'send_email_confirmations_to_customer': 'Send email confirmations to customer',
		'send_email_confirmations_to_merchant': 'Send email confirmations to merchant',
		'send_email_notification_on_appointment_events': 'Send email notification on appointment events',
		'send_magic_link': 'Send Magic Link',
		'send_password_reset': 'Send Password Reset',
		'service_hours': 'Service hours',
		'service_removed': 'Service removed',
		'service_updated': 'Service updated',
		'service': 'Service',
		'services': 'Services',
		'sesami_classic': 'Sesami Classic',
		'sesami_co_c': 'Sesami.co ©',
		'sesami_is': 'Sesami is',
		'sesami_status': 'Sesami Status',
		'sesami_v2': 'Sesami V2',
		'sesami': 'Sesami',
		'set_buffer_time_before_and_or_after_appointments_for_breaks_preparation_and_travel': 'Set buffer time before and/or after appointments, for breaks, preparation and travel.',
		'settings_updated': 'Settings updated',
		'settings': 'Settings',
		'shop': 'Shop',
		'shopify_product_option_duration_click_manage_to_modify_durations': 'Shopify product option, Duration. Click manage to modify durations.',
		'shops': 'Shops',
		'should_be_a_valid_json': 'Should be a valid JSON',
		'show_less': 'Show less',
		'show_more': 'Show more',
		'sign_up_is_not_available_yet': 'Sign up is not available yet',
		'slots_flexible_start': 'Slots flexible start',
		'something_internally_went_wrong_please_try_again_later': 'Something internally went wrong, please try again later.',
		'something_went_wrong_in_the_process': 'Something went wrong in the process.',
		'something_went_wrong': 'Something went wrong!',
		'start_from_scratch': 'Start From Scratch',
		'status': 'Status',
		'store_settings': 'Store Settings',
		'store_timezone': 'Store timezone',
		'storefront_calendar_start_date': 'Storefront calendar start date',
		'storefront_language': 'Storefront language',
		'storefront_settings': 'Storefront Settings',
		'storefront_start_date': 'Storefront start date',
		'storefront': 'Storefront',
		'subject': 'Subject',
		'sunday_sum': 'Sundays',
		'sync_your_events_to_calendar': 'Sync your events to calendar',
		'synced_event': 'Synced event',
		'target_of_your_flow_s_action': "Target of your flow's action",
		'target': 'Target',
		'team_member_created': 'Team member created',
		'team_member_is': 'Team member is',
		'team_member_removed': 'Team member removed',
		'team_member_select': 'Team member select',
		'team_member_updated': 'Team member updated',
		'team_member': 'Team member',
		'team_members': 'Team members',
		'team': 'Team',
		'the_app_should_not_be_installed_on_any_shop': 'The app should not be installed on any shop.',
		'the_appointment_cancelled': 'The appointment cancelled',
		'the_appointment_has_been_cancelled': 'The appointment has been cancelled',
		'the_appointment_has_been_marked_as_no_show': 'The appointment has been marked as no-show',
		'the_appointment_marked_as_checked_in': 'The appointment marked as checked in',
		'the_appointment_marked_as_no_show': 'The appointment marked as no show',
		'the_appointment_saved': 'The appointment saved',
		'the_code_is_case_sensitive': 'The code is case-sensitive',
		'the_code_you_entered_is_wrong_please_try_to_send_another_one': 'The code you entered is wrong; please try to send another one.',
		'the_customer_has_been_checked_in': 'The customer has been checked in',
		'the_email_already_exists_in_the_shop': 'The email already exists in the shop...',
		'the_email_confirmation_has_been_sent_to_the_customer': 'The email confirmation has been sent to the customer.',
		'the_event_that_starts_the_flow': 'The event that starts the flow',
		'the_flow_that_you_had_access_is_not_available': 'The flow that you had access is not available...',
		'the_invitation_link_has_been_expired': 'The invitation link has been expired',
		'the_link_sent_to_you_less_than_5_min_ago': 'The link sent to you less than 5 min ago.',
		'the_main_domain_of_the_app': 'The main domain of the app.',
		'the_name_is_used_before': 'The name is used before',
		'the_name_will_appear_just_to_you': 'The name will appear just to you.',
		'the_service_is_not_available': 'The service is not available',
		'the_service_that_you_had_access_is_not_available': 'The service that you had access is not available...',
		'the_sesami_button_will_be_visible': 'The Sesami button will be visible.',
		'the_sesami_button_will_disappear': 'The Sesami button will disappear.',
		'the_start_date_should_not_be_after_the_end_date': 'The start date should not be after the end date',
		'the_target_for_loading_the_extension': 'The target for loading the extension.',
		'the_target_will_pass_to_the_url_as_target': 'The target will pass to the URL as "?target={target}"',
		'the_team_member_should_not_be_assigned_to_any_services': 'The team member should not be assigned to any services.',
		'the_team_member_that_you_had_access_is_not_available': 'The team member that you had access is not available...',
		'the_the_sesami_button_will_disappear_by_disabling_sesami_here': 'The Sesami button will disappear by disabling Sesami here.',
		'the_title_will_be_shown_to_the_others': 'The title will be shown to the others',
		'the_type_of_action_to_do': 'The type of action to do',
		'the_url_does_not_need_to_be_unique_the_target_will_pass_to_it_at_the_loading_time': 'The URL does not need to be unique, the target will pass to it at the loading time.',
		'there_is_no_management_link': 'There is no management link.',
		'there_is_only_the_magic_link_is_available_for_you': 'There is only the magic link is available for you.',
		'this_feature_is_not_available_due_to_your_plan': 'This feature is not available due to your plan.',
		'this_field_is_required': 'This field is required',
		'this_flow_is': 'This flow is',
		'this_member_is_the_only_team_member_of_the_service': 'This member is the only team member of the service',
		'this_note_will_be_included_on_all_event_notifications_booked_with': 'This note will be included on all event notifications booked with.',
		'this_resource_does_not_exist_please_try_another_way': 'This resource does not exist, please try another way.',
		'this_will_be_included_in_the_notification_emails_and_calendar_events': 'This will be included in the notification emails and calendar events.',
		'this_will_not_remove_the_product_from_your_store': 'This will not remove the product from your store.',
		'this_will_not_remove_the_user_from_other_shops': 'This will not remove the user from other shops.',
		'thursday_sum': 'Thursdays',
		'time_format': 'Time format',
		'timeline': 'Timeline',
		'title': 'Title',
		'to_cancel_this_request_click_on_revoke': 'To cancel this request, click on "Revoke".',
		'to_change_the_email_you_have_to_revoke_the_google_calendar_sync': 'To change the email, you have to revoke the Google Calendar sync.',
		'to_colon': 'To:',
		'to_continue_choose_one_of_the_methods_below': 'To continue, choose one of the methods below.',
		'to': 'to',
		'today': 'Today',
		'trigger': 'Trigger',
		'tuesday_sum': 'Tuesdays',
		'twitter': 'Tweeter',
		'unavailable': 'Unavailable',
		'uninstall': 'Uninstall',
		'unknown': 'Unknown',
		'upcoming_appointments': 'Upcoming appointments',
		'upcoming': 'Upcoming',
		'upgrade': 'Upgrade',
		'url': 'URL',
		'use_flow': 'Use Flow',
		'use_this_to_identify_your_app': 'Use this to identify your app.',
		'user_can_access_to_a_specific_team_member': 'User can access to a specific team member.',
		'user_can_access_to_all_the_features': 'User can access to all the features.',
		'user_can_add_to_this_resource': 'User can add to this resource.',
		'user_can_just_open_and_see_the_resource': 'User can just open and see the resource.',
		'user_can_read_write_or_manage_a_flow': 'User can read, write, or manage a flow.',
		'user_can_read_write_or_manage_a_service': 'User can read, write, or manage a Service.',
		'user_has_no_permissions': 'User has no permissions',
		'user_not_found': 'User not found',
		'user_removed': 'User removed',
		'user_updated': 'User updated',
		'user': 'User',
		'users_list': 'Users List',
		'users': 'Users',
		'variant': 'Variant',
		'view_all': 'View all',
		'view_app': 'View app',
		'view_or_export_appointments': 'View or export appointments',
		'view_order': 'View order',
		'view_plans': 'View Plans',
		'vola_your_account_has_been_activated': 'Vola! Your account has been activated!',
		'vola_your_google_account_has_been_synced': 'Vola! Your Google account has been synced!',
		'vola': 'Vola!',
		'waiting_for_user_accept': 'Waiting for user accept.',
		'we_are_generating_your_report_you_will_receive_it_soon_on': 'We are generating your report; you will receive it soon on:',
		'we_cant_seem_to_find_the_right_email_for_you_are_you_sure_you_have_an_account': "We can't seem to find the right email for you. Are you sure you have an account?",
		'we_need_to_know_how_long_each_of_your_appointments_services_will_take_in_order_to_manage_your_calendar_please_add_at_least_one_variant_with_a_duration_option': "We need to know how long each of your appointments/services will take in order to manage your calendar. Please add at least one variant with a 'duration' option.",
		'webhook_sample_url': 'https://my.api.com/webhook',
		'webhook_template': 'Webhook template',
		'webhook': 'Webhook',
		'wednesday_sum': 'Wednesdays',
		'welcome_to_sesami': 'Welcome to Sesami!',
		'welcome': 'Welcome',
		'when_an_appointment_is_created_updated_an_email_including_a_calendar_event_will_be_sent_and_your_customer_will_be_added_as_an_attendee': 'When an appointment is created/updated, an email including a calendar event will be sent and your customer will be added as an attendee.',
		'when': 'When',
		'will_be_accessible_for_all_the_shops': 'Will be accessible for all the shops.',
		'write': 'Write',
		'you_can_add_multiple_uris_separated_with_comma': 'You can add multiple URIs separated with comma(,).',
		'you_can_disconnect_sesami_from_the_team_members_calendar_by_selecting_revoke_button': "You can disconnect Sesami from the team member's calendar by selecting \"Revoke\" button.",
		'you_can_enable_disable_the_flow_whenever_you_want': 'You can enable/disable the flow whenever you want.',
		'you_can_only_upload_jpg_png_file': 'You can only upload JPG/PNG file',
		'you_can_register_just_one_extension_for_each_target': 'You can register just one extension for each target.',
		'you_can_sync_sesami_team_member_calendars_to_google_calendar': "You can sync Sesami's team member calendars to Google Calendar.",
		'you_can_t_use_email_as_a_target_in_a_webhook_action': "You can't use email as a target in a webhook action",
		'you_can_t_use_email_variables_as_a_target_in_a_webhook_action': "You can't use email variables as a target in a webhook action",
		'you_can_upgrade_or_downgrade_your_plan_whenever_you_want': 'You can upgrade or downgrade your plan whenever you want.',
		'you_can_use_available_variables_in_your_email_subject': 'You can use available variables in your email subject.',
		'you_can_use_javascript_json_xml_or_any_form_of_data_that_your_api_requires': 'You can use Javascript, JSON, XML, or any form of data that your API requires.',
		'you_cannot_add_your_email': 'You cannot add your email!',
		'you_dont_have_access_to_create_a_user': "You don't have access to create a user",
		'you_exceeded_the_max_apps_limit': 'You exceeded the max apps limit!',
		'you_have_a_different_login_method': 'You have a different login method',
		'you_have_previously_defined_date_specific_rules_for_these_dates': 'You have previously defined date-specific rules for these dates:',
		'you_logged_in_with_your_google_account_before': 'You logged in with your Google account before.',
		'you_reached_the_limit_please_try_again_in_minutes_later': 'You reached the limit, please try again in {time} minutes later.',
		'you_reached_your_plans_max_limit': "You reached your plan's max limit",
		'your_account_has_not_been_activated_yet_you_can_activate_your_account_by_opening_the_activation_link_that_sent_to_your_email_before': 'Your account has not been activated yet, you can activate your account by opening the activation link that sent to your email before.',
		'your_appointments_report_is_being_generated': 'Your appointments report is being generated',
		'your_apps_client_id_is': "Your app's client ID is:",
		'your_can_disconnect_sesami_from_team_members_calendar_by_selecting_revoke_button': 'Your password is wrong! Make sure that you are typing it correctly.',
		'your_order_is_completed': 'Your order is completed',
		'your_password_has_been_reset': 'Your password has been reset',
	}
}
